import React from "react";
import { Formik } from "formik";
import {
  Button,
  ButtonSet,
  Form,
  FormGroup,
  Loading,
  TextInput,
  NumberInput,
} from "carbon-components-react";
import { LoadingState } from "underwriter_dashboard/shared/types";

import { EditingState } from "web_modules/shared/BaseTable";

import { validationSchema } from "./FormValues";

interface Props {
  formState: any;
  onSubmit: any;
  editingMode: EditingState;
  onRequestClose: Function;
  loading: LoadingState;
}

const AddLenderCreditsForm: React.FC<Props> = ({
  formState,
  onSubmit,
  editingMode,
  onRequestClose,
  loading,
}) => {
  const submitForm = async (values, { setSubmitting, setStatus, resetForm, setErrors }) => {
    try {
      await onSubmit(values);

      // after submit
      resetForm({});
      setStatus({ success: true });
    } catch (error) {
      // on error
      setStatus({ success: false });
      setSubmitting(false);
      setErrors({ submit: error.message });

      throw error;
    }
  };

  return (
    <>
      <Loading active={loading === LoadingState.ACTIVE} />
      <Formik
        enableReinitialize
        onSubmit={submitForm}
        initialValues={formState}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          isSubmitting,
        }) => {
          const { description, amount } = values;

          return (
            <Form
              onSubmit={e => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <FormGroup legendText="">
                <TextInput
                  id="description"
                  name="description"
                  disable={isSubmitting}
                  size="sm"
                  value={description}
                  labelText="Description"
                  placeholder="description"
                  type="text"
                  invalid={!!errors.description && touched.description}
                  invalidText={errors.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <NumberInput
                  id="amount"
                  name="amount"
                  disable={isSubmitting}
                  label="Amount"
                  value={amount}
                  invalid={!!errors.amount && touched.amount}
                  invalidText={errors.amount}
                  onBlur={handleBlur}
                  onChange={(e, f, val) => {
                    // if you click the up or down button rather than entering
                    // number you get 2 different events that need to be
                    // resolved.
                    if (e.type === "click") {
                      handleChange({
                        ...e,
                        target: {
                          ...e.target,
                          name: "tridCure",
                          value: val,
                        },
                      });
                    } else {
                      handleChange(e);
                    }
                  }}
                />
              </FormGroup>

              <ButtonSet>
                <Button
                  kind="secondary"
                  size="lg"
                  onClick={() => {
                    resetForm();
                    onRequestClose();
                  }}
                  style={{ maxWidth: "50%" }}
                  disable={isSubmitting ? "true" : "false"}
                >
                  Cancel
                </Button>
                <Button
                  kind="primary"
                  size="lg"
                  type="submit"
                  style={{ maxWidth: "50%" }}
                  disable={isSubmitting ? "true" : "false"}
                >
                  {editingMode === EditingState.CREATE ? "Save" : "Update"}
                </Button>
              </ButtonSet>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddLenderCreditsForm;
